import React, { Component } from 'react';
import Aux from '../Hoc/Aux.js';
import iconSpeak from '../../assets/svg/icon-speak.svg';
import iconNetwork from '../../assets/svg/icon-in-out.svg';
// import iconCheckList from '../../assets/svg/icon-checks.svg';
// import iconBill from '../../assets/svg/icon-bill.svg';
import iconAward from '../../assets/svg/icon-award2.svg';
// import iconSavings from '../../assets/svg/icon-savings.svg';
import iconGym from '../../assets/svg/icon-gym-02.svg';
import Connect from '../../components/Forms/Connect';

class Reasons extends Component {
  state = {
    showModal: false
  };

  showQuoteOverlay = () => {
    this.setState({ showModal: true });
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  render () {
    // const largeReasonsList = [
    //   {
    //     icon: iconCheckList,
    //     alt: 'Traditional fully-insured plan',
    //     text: (<p>Traditional fully-insured plans that are competitively priced and build on value-added benefits and wellness programs.</p>)
    //   },
    //   {
    //     icon: iconBill,
    //     alt: 'Self-funded options',
    //     text: (<p>Self-funded plans that offer maximum control over design and cost, plus innovative ways to keep employees healthy.</p>)
    //   },
    //   {
    //     icon: iconNetwork,
    //     alt: 'Robust provider network',
    //     text: (<p>Robust provider network that includes over 1,000,000 providers nationwide.</p>)
    //   },
    //   {
    //     icon: iconSpeak,
    //     alt: 'Call local reps',
    //     text: (<p>Award-winning, personalized service that provides exceptional support and responsiveness for you and your team.</p>)
    //   }
    // ];

    const smallReasonsList = [
      {
        icon: iconAward,
        alt: 'Physicals and preventive screenings',
        text: (<p>HMO plans rated 5 out of 5 stars and PPO plans rated 4.5 out of 5 stars, collectively among the highest-rated plans in the nation.*</p>)
      },
      {
        icon: iconNetwork,
        alt: 'Robust provider network',
        text: (<p>Robust provider network that includes over 1,000,000 providers nationwide.</p>)
      },
      {
        icon: iconGym,
        alt: 'Gym memberships',
        text: (<p>Up to $2,500 in reimbursements for gym memberships, youth sports fees, doula services, and more!</p>)
      },
      {
        icon: iconSpeak,
        alt: 'Call local reps',
        text: (<p>Award-winning, personalized service that provides exceptional support and responsiveness for you and your team.</p>)
      }
    ];

    return (
      <Aux>
        <section className='divide p60'>
          <div className='wrap'>
            <h2>Big advantages for small&nbsp;groups.</h2>
            <ul className='small-biz-reasons'>
              {smallReasonsList.map((reason, index) => (
                <li className='col' key={index}>
                  <span><img src={reason.icon} alt={reason.alt} /></span>
                  {reason.text }
                </li>
              ))}
            </ul>
            <div className='actions'>
              <p className='text-center'><a href='/small-business/find-a-plan/start' className='btn'>Compare Plans &amp; Get a Quote</a></p>
            </div>
          </div>
        </section>
        {/* <span id='large'>&nbsp;</span>
        <section className='divide p60'>
          <div className='wrap'>
            <h2>Custom options for large&nbsp;groups</h2>
            <ul className='small-biz-reasons'>
              {largeReasonsList.map((reason, index) => (
                <li className='col' key={index}>
                  <span><img src={reason.icon} alt={reason.alt} /></span>
                  {reason.text }
                </li>
              ))}
            </ul>
            <div className='actions'>
              <p className='text-center'><button onClick={this.showQuoteOverlay} className='btn'>Connect with Us</button></p>
            </div>
          </div>
        </section> */}
        <Connect
          area='LargeGroupLead'
          closeModal={this.closeModal}
          gaEventLabel='Plans - Large Group Lead'
          show={this.state.showModal} />
      </Aux>
    );
  }
}

export default Reasons;
